import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['editIcon', 'textField']

  declare editIconTarget: HTMLElement;
  declare textFieldTarget: HTMLInputElement;

  private lastSavedValue: string = '';

  connect(): void {
    this.lastSavedValue = this.textFieldTarget.value;
  }

  public handleEditIcon(): void {
    this.hideEditIcon();
    this.textFieldTarget.select();
  }

  public showEditIcon(): void {
    this.editIconTarget.style.visibility = 'visible';
  }

  public hideEditIcon(): void {
    this.editIconTarget.style.visibility = 'hidden';
  }

  public submitOnChange(): void {
    const currentValue = this.textFieldTarget.value;
    if (currentValue === this.lastSavedValue) return;

    this.lastSavedValue = currentValue;
    const form = this.textFieldTarget.closest('form');
    if (!form) return;

    if (typeof (window as any).Rails !== 'undefined') {
      (window as any).Rails.fire(form, 'submit');
    } else {
      form.requestSubmit();
    }
  }
}
